import React from "react";
import { BiWallet } from "react-icons/bi";
import { BsCalendar2Week } from "react-icons/bs";
import { IoFlashOutline } from "react-icons/io5";

import SimpleButton from "@/components/Buttons/SimpleButton";
import {
  CardRow,
  CardRowActions,
  CardRowCell,
  CardRowCells,
  CardRowDivider,
} from "@/components/CardRow";

import { ContaProps } from "./types";

const Conta = ({ month, value, kilowatts, status, buttonLabel, onClick }: ContaProps) => {
  return (
    <CardRow>
      <CardRowCells>
        <CardRowCell label="MÊS" value={month} icon={<BsCalendar2Week />} />
        <CardRowCell label="VALOR" value={value} icon={<BiWallet />} />
        <CardRowCell
          label="KILOWATTS"
          value={kilowatts}
          valueSuffix=" kWh"
          icon={<IoFlashOutline />}
        />
      </CardRowCells>
      <CardRowActions>
        <CardRowCell
          label="SITUAÇÃO"
          status={{
            label: status,
            tone: status === "Pago" || status === "Ativo" ? "success" : "danger",
          }}
        />
        <CardRowDivider />
        <SimpleButton variant="simple" onClick={onClick} label={buttonLabel} />
      </CardRowActions>
    </CardRow>
  );
};

export default Conta;
